import type { RouteObject } from "react-router-dom";
import { page } from "@/app/page";

// NB: /app and /apps are reserved by Traefik for Reverb, hence /applications.
export const appsRoutes: RouteObject[] = [
  { id: "apps.applications", path: "/applications", element: page(() => import("@/screens/apps/Applications")) },
];
